import { forwardRef } from 'react';
import { STATIC_LIST_TYPES } from 'modules/workflows/constants/triggers';

import {
  ExternalValue,
  InternalOnChangeProp,
} from 'modules/workflowNodeEditors/editorComponents/ResourceSelect/ResourceSelect.types';
import { FilterSegmentResourceSelect } from '../../FilterSegmentResourceSelect';
import { FilterSegmentErrorButton } from '../../FilterSegmentErrorButton';
import { FilterSegmentButton } from '../../FilterSegmentButton';
import { FilterSegmentSelectInputOption } from '../../../FilterInputsList.types';

const displayText = {
  placeholder: 'Select a subscriber list...',
  loading: 'Loading lists...',
};

type FilterListMembershipValueInputProps = {
  onChange: (value: ExternalValue) => void;
  value: string;
  id: string;
  isDisabled?: boolean;
  hasError?: boolean;
  placeholder?: string;
};

type TriggerProps = {
  children?: React.ReactNode;
  selectedOptions: FilterSegmentSelectInputOption[];
  toggleDropdown: () => void;
  isOpen: boolean;
  isError: boolean;
  isDisabled: boolean;
  placeholder: string;
};

const Trigger = forwardRef<HTMLDivElement, TriggerProps>(
  ({ toggleDropdown, isOpen, isError, isDisabled, placeholder, children }, ref) => {
    const ButtonComponent = isError ? FilterSegmentErrorButton : FilterSegmentButton;
    return (
      <div ref={ref}>
        <ButtonComponent onClick={toggleDropdown} isToggled={isOpen} isDisabled={isDisabled}>
          {children || placeholder}
        </ButtonComponent>
      </div>
    );
  },
);

export const FilterListMembershipValueInput = ({
  id,
  onChange,
  value,
  isDisabled = false,
  hasError = false,
  placeholder,
}: FilterListMembershipValueInputProps) => {
  const handleChange = (args: InternalOnChangeProp) => {
    onChange(args?.value);
  };

  return (
    <FilterSegmentResourceSelect
      id={id}
      listType={STATIC_LIST_TYPES}
      onChange={handleChange}
      value={value}
      hasError={hasError}
      isDisabled={isDisabled}
      placeholder={placeholder || displayText.placeholder}
      Trigger={Trigger}
    />
  );
};
